import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";
export const getBannersFunc = createAsyncThunk(
  "getAllBanners",
  async (query = "", thunkAPI) => {
    try {
      const res = await api.get(`dashboard/general-settings/banners${query}`);
      
      return res.data.data.banners;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getBannersSlicer = createSlice({
  name: "getAllBanners",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBannersFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getBannersFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getBannersFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getBannersSlicer.reducer;
